import { render, staticRenderFns } from "./CompetitionFixtures.vue?vue&type=template&id=5b240bd1&scoped=true"
import script from "./CompetitionFixtures.vue?vue&type=script&lang=ts"
export * from "./CompetitionFixtures.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionFixtures.vue?vue&type=style&index=0&id=5b240bd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b240bd1",
  null
  
)

export default component.exports